import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import {
  HTTPValidationError,
  ICreateQueryBulResponse,
  ICreateQueryResponse,
  ISuccessfulResponse
} from 'src/types/QueryResponse';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const queryResponseApi = createApi({
  baseQuery,
  reducerPath: 'queryResponseApi',
  endpoints: builder => ({
    createQueryResponse: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        query_id: string;
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        data: ICreateQueryResponse;
        application_section: string;
        application_module_section: string;
      }
    >({
      query: ({
        query_id,
        site_id,
        study_id,
        country,
        application,
        data,
        application_section,
        application_module_section
      }) => ({
        url: formatString(
          endPoints.QueryResponse.create,
          { key: urlKeys.query_id, value: query_id },
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section },
          { key: urlKeys.application_module_section, value: application_module_section }
        ),
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createQueryBulkResponse: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        data: ICreateQueryBulResponse;
        application_section: string;
        application_module_section: string;
      }
    >({
      query: ({ site_id, study_id, country, application, data, application_section, application_module_section }) => ({
        url: formatString(
          endPoints.QueryResponse.bulkCreate,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section },
          { key: urlKeys.application_module_section, value: application_module_section }
        ),
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getQueryResponse: builder.query<
      ISuccessfulResponse | HTTPValidationError,
      {
        query_id: string;
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string;
        application_module_section: string;
      }
    >({
      query: ({
        query_id,
        site_id,
        study_id,
        country,
        application,
        application_section,
        application_module_section
      }) => ({
        url: formatString(
          endPoints.QueryResponse.select,
          { key: urlKeys.query_id, value: query_id },
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section },
          { key: urlKeys.application_module_section, value: application_module_section }
        ),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useCreateQueryResponseMutation, useGetQueryResponseQuery, useCreateQueryBulkResponseMutation } =
  queryResponseApi;
